import React from "react";
import Bets from "../CrashGame/Bets/Bets";
import StatusBar from "../CrashGame/StatusBar/StatusBar";
import Panel from "../Panel/Panel";

const bets = {
  "1234089": {
    "id": "1234089",
    "sum": "1760",
    "username": "camat izaev",
    "closed": true,
    "cf": "2.38"
  },
  "1234090": {
    "id": "1234090",
    "sum": "400",
    "username": "ram666",
    "closed": true,
    "cf": "1.6"
  },
  "1234091": {
    "id": "1234091",
    "sum": "190",
    "username": "Ura19791",
    "closed": true,
    "cf": "1.53"
  },
  "1234092": {
    "id": "1234092",
    "sum": "94",
    "username": "alik555",
    "closed": true,
    "cf": "1.3"
  },
  "1234093": {
    "id": "1234093",
    "sum": "50",
    "username": "Samara.163",
    "closed": true,
    "cf": "1.7"
  },
  "1234094": {
    "id": "1234094",
    "sum": "530",
    "username": "LORA1",
    "closed": true,
    "cf": "1.5"
  },
  "1234095": {
    "id": "1234095",
    "sum": "10",
    "username": "Yubasup",
    "closed": true,
    "cf": "1.84"
  }
};

export default class UI extends React.PureComponent {
  render() {
    return (
      <div className="ui-page">
        <div style={{ width: "960px", height: "500px", margin: "40px", padding: "20px" }}>
          <StatusBar status={0} bets={bets} />
          <Bets bets={bets} currentCf={2} />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/components/UI/UI.jsx